import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CodigoBarraFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COD. BARRA' htmlFor='select-codigoBarra' xs={4} alignRightAt='xs' />
      <Col xs={8}>
        <Field name='codigoBarra'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-codigoBarra'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoBarraFormGroup)
